











































import Vue from 'vue';

export default Vue.extend({
  props: {
    type: {
      type: String,
      required: true,
      validator: (val: string) => ['question', 'article'].includes(val),
    },
    material: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      materialType: this.type === 'question' ? 'questão' : 'explicação',
    };
  },
});
